import React from "react";

const NotFound = () => {
    window.location.href = '/'
    return false
}

export default NotFound;
